// noinspection HtmlUnknownTarget

import React from 'react';
import { FaFacebook } from 'react-icons/fa';
import mobileChat from '~/assets/mobile-chat.svg';
import cn from 'classnames';

interface InfluencerRegistrationProps {
  showCheckYourTexts: boolean;
}

const InfluencerRegistration: React.FC<InfluencerRegistrationProps> = ({
  showCheckYourTexts,
}) => {
  const inputClasses = 'border p-2 rounded block w-full mb-4';

  return (
    <div>
      {showCheckYourTexts && (
        <div className={'mb-4 bg-gray-100 rounded-2xl p-4 flex items-center '}>
          <img src={mobileChat} alt={'Mobile chat'} className={'mr-2'} />

          <div>
            <div className={'font-bold text-lg'}>Check Your Texts!</div>
            <div className={'text-gray-700'}>
              Reply &ldquo;YES&rdquo; to confirm.
            </div>
          </div>
        </div>
      )}

      <p className={'my-6'}>
        Live sale products sell out quickly, so sign up now to save time during
        the event!
      </p>

      <a className={'w-full'} href={'/facebook-login'}>
        <button
          className={
            'flex-1 w-full rounded-lg text-white font-bold p-2 flex items-center justify-center'
          }
          style={{ backgroundColor: 'rgba(24, 119, 242, 1)' }}
        >
          <FaFacebook className={'mr-2 inline'} color="white" />
          Continue With Facebook
        </button>
      </a>

      <p className={'my-6 text-center font-semibold'}>or</p>

      <form acceptCharset="UTF-8" action="/customers/register" method="POST">
        <label htmlFor={'firstName'}>First Name</label>
        <input
          id="firstName"
          required={true}
          name="customer[first_name]"
          className={inputClasses}
        />

        <label htmlFor={'lastName'}>Last Name</label>
        <input
          id={'lastName'}
          required={true}
          name="customer[last_name]"
          className={inputClasses}
        />

        <label htmlFor={'email'}>Email</label>
        <input
          id={'email'}
          type="email"
          required={true}
          name="customer[email]"
          className={inputClasses}
        />

        <label htmlFor={'password'}>Password</label>
        <input
          id={'password'}
          type="password"
          required={true}
          name="customer[password]"
          className={inputClasses}
        />

        <button
          type="submit"
          className={cn(
            'mt-4 w-full flex items-center justify-center p-4 rounded-lg text-base text-white font-bold bg-blackForReal',
          )}
        >
          Sign Up
        </button>
      </form>
    </div>
  );
};

export { InfluencerRegistration };
